import { Modal } from "react-bootstrap";
import { ModalInformationContentStyled, ModalInformationStyled, ModalWrapperStyled } from "../styled/ModalsStyled.js";
import WithdrawCancel from "../../Withdrawal/components/WithdrawCancel";
import { useMemo } from 'react';
import { useLocation } from 'react-router';

function WithdrawCancelModal() {
    const location = useLocation();
    const uuid = useMemo(() => new URLSearchParams(location.search).get('uuid'), [location]);

    return <ModalInformationStyled>
        <Modal.Header style={{ background: 'transparent' }} closeButton/>
        <ModalWrapperStyled>
            <ModalInformationContentStyled>
                <WithdrawCancel uuid={uuid}/>
            </ModalInformationContentStyled>
        </ModalWrapperStyled>
    </ModalInformationStyled>
}

export default WithdrawCancelModal;
